import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteExtraServiceGroupSaga,
  getExtraServiceGroupDetailsSaga,
  getExtraServiceGroupListSaga,
} from "src/store/extra-service-group/saga";
import {
  ExtraServiceGroupDetailDto,
  ExtraServiceGroupDto,
} from "src/store/extra-service-group/type";
import ExtraServiceGroupCreateForm from "./create";
import ExtraServiceGroupEditForm from "./edit";
const ExtraServiceGroupPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<ExtraServiceGroupDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ExtraServiceGroupDetailDto>();
  const columns = [
    {
      text: t("ExtraServiceGroup.Sector"),
      dataField: "SectorName",
    },
    {
      text: t("ExtraServiceGroup.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("ExtraServiceGroup.PageTitle")}
        metaTag={t("ExtraServiceGroup.MetaTag")}
        gridProps={{
          addTitle: t("ExtraServiceGroup.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getExtraServiceGroupListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getExtraServiceGroupDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: ExtraServiceGroupDto) =>
              t("ExtraServiceGroup.DeleteQA", {
                name: data.Name,
              }),
            action: deleteExtraServiceGroupSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <ExtraServiceGroupCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getExtraServiceGroupListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ExtraServiceGroupEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getExtraServiceGroupListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ExtraServiceGroupPage;
